import { fields, setFieldOptions } from "../components/field";

interface Subdision {
  code: string;
  short_code: string;
  name: string;
}

interface Country {
  alpha2: string;
  name: string;
}

const initIsocodes = async () => {
  const getFields = () =>
    fields().filter((field) =>
      field.inputElement?.hasAttribute("data-isocodes")
    );

  if (getFields().length === 0) {
    return;
  }

  const getCountries = async (): Promise<Country[]> => {
    const response = await fetch(`/actions/isocodes/countries`);

    return await response.json();
  };

  const getSubdivisions = async (
    countryAlpha2: string
  ): Promise<Subdision[]> => {
    const response = await fetch(
      `/actions/isocodes/subdivisions?country=${countryAlpha2}`
    );

    return await response.json();
  };

  const countries = await getCountries();

  getFields().forEach((field, index) => {
    if (field.inputElement?.dataset.isocodes !== "country") {
      return;
    }

    const updateSubdivisionsRelatedField = async () => {
      const country = field.inputElement?.value;

      if (!country) {
        return;
      }

      // Find the adjacent field and assume it's the pair subdivison field.
      const subdivisionField = getFields()[index + 1];

      if (!subdivisionField) {
        console.debug("No subdivision field pair for country field.");
        return;
      }

      if (subdivisionField.inputElement?.dataset.isocodes !== "subdivision") {
        throw new Error("Could not find pair subdivision field.");
      }

      setFieldOptions(
        subdivisionField,
        (await getSubdivisions(country)).map((subdivision) => {
          return {
            value: subdivision.short_code,
            label: subdivision.name,
          };
        })
      );
    };

    setFieldOptions(
      field,
      countries.map((country) => {
        return {
          value: country.alpha2,
          label: country.name,
        };
      })
    );

    updateSubdivisionsRelatedField();

    field.inputElement?.addEventListener(
      "change",
      updateSubdivisionsRelatedField
    );
  });
};

export default initIsocodes();
